import {javaScriptEditor} from '../JavaScriptEditor';

import 'fomantic-ui-less/definitions/behaviors/api';
import 'fomantic-ui-less/definitions/modules/transition';
import 'fomantic-ui-less/definitions/modules/modal';
import 'fomantic-ui-less/definitions/modules/dimmer';
import 'fomantic-ui-less/definitions/modules/dropdown';

import {workflowDefinitionVersionsSelectDropdown} from './dropdowns';
import {api} from './fetchWithTimeout';
import {parseJSON, stringifyJSON} from './json';
import {createLogger} from './logger';
import isEmpty from 'lodash/isEmpty';

const LOGGER = createLogger('WorkflowRun');

const delay = delayMilliseconds => new Promise(resolve => setTimeout(resolve, delayMilliseconds));

const redirectToWorkflow = (modal, workflowId, count = 0) => {
  if (count > 20) {
    document.querySelectorAll('#workflowRunForm .ui.button').forEach(button => {
      button.classList.remove('disabled', 'labeled', 'icon');
      button.querySelectorAll('.loading.spinner').forEach(el => el.remove());
    });
    document.getElementById('workflowRunError').classList.remove("hidden");
    return;
  }

  api(`/api/workflows/${workflowId}`, {
    method: 'GET',
    headers: {
      'Accept': 'application/json'
    }
  }).then(workflow => {
    const url = `/workflows/${workflow.id}${isEmpty(workflow.workflowDefinitionVersion) ? '' : `?version=${workflow.workflowDefinitionVersion}`}`;

    if (document.getElementById('newBrowserTab').checked) {
      window.open(url, "_blank");
    } else {
      window.location = url;
    }

    modal.modal('hide');
  }).catch(() => {
    delay(1000).then(() => redirectToWorkflow(modal, workflowId, count + 1));
  });
}

export const workflowRun = (currentWorkflowDefinition, workflowName) => {
  const modal = $.modal({
    title: `Run ${workflowName}`,
    content: `
        <div id="workflowRunError" class="ui message error hidden">Sorry! We are temporarily unable to run the workflow. Please try again. If you continue to see this error or have issues in general, <a href="/contact" target="_blank">contact us</a>.</div>
        <form id="workflowRunForm" class="ui form" novalidate>
        <div class="field">
          <label for="workflowInput">Input</label>
          <textarea id="workflowInput" name="workflowInput" class="json-editor" rows="5"></textarea>
          <div class="ui pointing basic large label">Enter input values for this workflow run in JSON format</div>
        </div>
        <div class="field">
          <label for="workflowVersion">Version</label>
          <div id="workflowVersionDropdown" class="ui fluid selection dropdown">
            <input type="hidden" id="workflowVersion" name="workflowVersion">
            <div class="default text">Latest revision</div>
            <i class="dropdown icon"></i>
            <div class="menu">
            </div>
          </div>
        </div>
        <div class="field">
          <div class="ui checkbox">
              <input id="newBrowserTab" name="newBrowserTab" type="checkbox">
              <label for="newBrowserTab">Open in a new browser tab</label>
          </div>
        </div>
      </form>`,
    actions: [{
      text: 'Run',
      class: 'small ok primary'
    },{
      text: 'Cancel',
      class: 'small cancel'
    }],
    preserveHTML: true,
    duration: 0,
    closeIcon: true,
    closable: false,
    onApprove : function($element) {
      $element[0].classList.add('disabled', 'labeled', 'icon');
      $element[0].insertAdjacentHTML('afterbegin', '<i class="loading spinner icon"></i>');
      document.getElementById('workflowRunError').classList.add("hidden");

      api('/api/workflows', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: stringifyJSON({
          workflowDefinitionId: currentWorkflowDefinition.id,
          workflowDefinitionVersion: document.getElementById('workflowVersion').value,
          input: parseJSON(document.getElementById('workflowInput').value)
        })
      })
      .then(workflowId => redirectToWorkflow(modal, workflowId))
      .catch(error => {
          LOGGER.error('Unable to run workflow', error);
          $element[0].classList.remove('disabled', 'labeled', 'icon');
          $element[0].querySelectorAll('.loading.spinner').forEach(el => el.remove());
          document.getElementById('workflowRunError').classList.remove("hidden");
      });

      return false;
    },
    onShow: () => {
      javaScriptEditor(document.getElementById('workflowInput'), {
        "comment": "Insert your JSON here"
      });

      workflowDefinitionVersionsSelectDropdown({
        element: document.getElementById('workflowVersionDropdown'),
        workflowDefinitionId: currentWorkflowDefinition.id,
        value: currentWorkflowDefinition.version
      });
    }
  });

  modal.modal('show');
}